export default __webpack_public_path__ + "static/media/Arcfire Opus.95c52db1.jpg";